'use client';

import React, { useEffect } from 'react';
import Filters from './filter';
import ProductionConsumptionTable from './table';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import {
  selectMaterialDetailData,
  selectMaterialDetailError,
  selectMaterialDetailLoading,
} from '../../store/material-detail.selectors';
import { getMaterialDetail } from '../../store/material-detail.thunk';
import { useNavigate, useParams } from 'react-router-dom';
import { replacePlaceholders } from '@/utils/helpers';
import routes from '@/app/routes';
import type {
  Material,
  MaterialComponent,
  MaterialRouting,
} from '../../utils/match-maker.types';

const ProductionConsumptionListWrapper: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { materialId } = useParams();
  const materialDetail = useAppSelector(selectMaterialDetailData);
  const isLoading = useAppSelector(selectMaterialDetailLoading);
  const error = useAppSelector(selectMaterialDetailError);

  useEffect(() => {
    if (materialId) {
      dispatch(getMaterialDetail({ id: materialId }));
    }
  }, [dispatch, materialId]);

  const onClickSelect = (
    item: Material | MaterialComponent | MaterialRouting | undefined
  ) => {
    if (materialId && item) {
      navigate(
        replacePlaceholders(routes.MATCH_MAKER_MATCH_WITH_SOFTTAG, {
          materialId,
          componentId: item?.id,
        }),
        {
          state: {
            selectedItem: item,
          },
        }
      );
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg bg-white w-full">
      <Filters isLoading={isLoading} />
      <ProductionConsumptionTable
        material={materialDetail}
        isLoading={isLoading}
        error={error}
        onClickSelect={onClickSelect}
      />
    </div>
  );
};

export default ProductionConsumptionListWrapper;
